import { render, staticRenderFns } from "./Create-Or-Update-SerialNumber.vue?vue&type=template&id=47bb81e2&scoped=true"
import script from "./Create-Or-Update-SerialNumber.vue?vue&type=script&lang=js"
export * from "./Create-Or-Update-SerialNumber.vue?vue&type=script&lang=js"
import style0 from "./Create-Or-Update-SerialNumber.vue?vue&type=style&index=0&id=47bb81e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb81e2",
  null
  
)

export default component.exports